var signature = "";
var AccessKey = "efa146311ff59066";
var scanID = "";
var overlaySignature = "";
var retakeStatus = "false";

var check_id = getCookie('vtoscanid');
var check_overlaySignature = getCookie('vtooverlay');

console.log('data', check_id);

if (check_id !== undefined) {
  
	setTimeout(function(){ getToken(); }, 1000);

}


document.addEventListener("DOMContentLoaded", function(event) { 
	let container = document.getElementById("ditto-container");
  	let background = document.getElementById("modal-background");
  	container.addEventListener("click", function(){
//       container.style.opacity = 0;
      container.style.visibility = "hidden";
    });
  
  	let check_total_var = document.getElementsByName('Color');
      
  	if(check_total_var.length > 1) {

//       $('.selector-wrapper .swatch input').on('change', function(){
//         let get_color_var_single_product = $('.selector-wrapper .swatch input:checked').val();
        
// //         console.log('sini', get_color_var_single_product);
//         let get_id = $('[name="Color"]:checked').val();
// 		let get_id_send = $('.dir_sku span:contains('+get_id +')').attr('data-sku');
//         console.log('sini-2', get_id_send);
//         changeTryOnVariant(get_id_send);
//       });
  	}
});

      $('.selector-wrapper .swatch input').on('click', function(){
        
        var check_id = getCookie('vtoscanid');
        var check_overlaySignature = getCookie('vtooverlay');
        
        let get_color_var_single_product = $('.selector-wrapper .swatch input:checked').val();
        
        let get_id = $('[name="Color"]:checked').val();
		let get_id_send = $('.dir_sku span:contains('+get_id +')').attr('data-sku');
        
        if (check_id != undefined) {
			reTakeSignature();
        }
        
      });




function checkVTO(){
  scanID = getCookie('vtoscanid');
  overlaySignature = getCookie('vtooverlay');
  
  if(scanID != undefined && overlaySignature != undefined){
//     console.log('sini', overlaySignature);
    let get_color_var_single_product = $('.selector-wrapper .swatch input:checked').val();
        
    let get_id = $('[name="Color"]:checked').val();
    let get_id_send = $('.dir_sku span:contains('+get_id +')').attr('data-sku');
// 	console.log('sini-2', get_id_send);
    changeTryOnVariant(get_id_send);
  }else if (scanID != undefined && overlaySignature == undefined){
  	reTakeSignature();
  }else{
  	initDitto();
  }
}


function reTakeSignature() {
  var get_id = $('[name="Color"]:checked').val();
  var check_id = getCookie('vtoscanid');
  let get_id_send = $('.dir_sku span:contains('+get_id +')').attr('data-sku');
  console.log('retakeoverlay2');
  
  $.get("/tools/token/ditto-auth-credentials/?message=" + check_id, function(response) {
    var options = {
  		"tryOnServer":"https://vto.partners-au.api.ditto.com",
  		"domSelector":"#ditto-tryon",
  		"glassesId":get_id_send,
  		"partnerId":"projectsoul",
  		"accessKey":response['X-Ditto-Access-Key-Id'],
  		"scanId":check_id,
  		"overlaySignature":response['X-Ditto-Signature'],
  		"disablePreview":false
    };
    var overlay = new Ditto.Overlay(
      options,
      {
        initialized: function() {
          console.log("initialized");
        },
        success: function() {
          console.log("Success");
        },
        failure: function() {
          console.log("Failure");
        },
        onclick: function() {
          console.log("Optional Event: Click of VTO");
        }
      }
    );
  });
  
}

function getCookie (name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}


function initDitto(){
  var get_id = $('[name="Color"]:checked').val();
  var get_id_send = $('.dir_sku span:contains('+get_id +')').attr('data-sku');

//   let container = document.getElementById("ditto-scan");
//   container.classList.remove("active");
  
//   let x = document.getElementsByClassName("first-ditto");
//   x[0].style.display = "none";
  
  let lastElements = document.getElementsByClassName("DittoSandbox");
  while(lastElements.length > 0){
    lastElements[0].parentNode.removeChild(lastElements[0]);
  }
  
  let container = document.getElementById("ditto-container");
  container.style.opacity = 1;
  container.style.visibility = "visible";
 
  var scan = new Ditto.Scan(
  {
    tryOnServer: "https://vto.partners-au.api.ditto.com",
    partnerId: "projectsoul",
    font: "opensans",
    domSelector: "#ditto-container",
    accessKey: AccessKey,
    partnerSignature: signature
  },
  {
    success: function(response){ 
      console.log("success scan", response.scanId);
      scanID = response.scanId;
      overlaySignature = response.overlaySignature;
      console.log('overlaySignature', overlaySignature);
      let scanContainer = document.getElementById("scan-iframe");
      scanContainer.style.display = "none";
      $('#ditto-tryon').addClass('scan-opened');

      ga('send', 'event', 'Ditto', 'Success', 'IndexPage');
//         document.cookie = "vtoscanid="+scanID+"; max-age=" + 1*60*60 + "; path=/;";
// 		document.cookie = "vtooverlay="+overlaySignature+"; max-age=" + 1*60*60 + "; path=/;";


      
      var overlay = new Ditto.Overlay(
        {
          tryOnServer: "https://vto.partners-au.api.ditto.com",
          partnerId: "projectsoul",
          domSelector: "#ditto-tryon",
          scanId: scanID,
          glassesId: get_id_send,
          overlaySignature: overlaySignature,
          accessKey: AccessKey
        },
        {
          initialized: function() {
            console.log("initialized");
          },
          success: function() {
			jQuery('button.btn-scan').html('Retake');
            jQuery('button.btn-scan').attr('retake', 'true');
            console.log('overlaySignature', overlaySignature);
//             let closeButton = document.getElementsByClassName("try-close");
// 	      	closeButton[0].style.display = "block";
      
        document.cookie = "vtoscanid="+scanID+"; max-age=" + 14*24*60*60 + "; path=/;";
		document.cookie = "vtooverlay="+overlaySignature+"; max-age=" + 1*60*60 + "; path=/;";

           
            
            let x = document.getElementsByClassName("first-ditto");
//             x[0].style.display = "none";
//             container.style.opacity = 0;
            container.style.visibility = "hidden";
          },
          failure: function() {
            console.log("Failure");
//             container.style.opacity = 0;
            container.style.visibility = "hidden";
          },
          onclick: function() {
            console.log("Optional Event: Click of VTO");
          }
        }
      );
    },
    failure: function(response) {
      console.log("failure", response);
      ga('send', 'event', 'Ditto', 'Success', 'IndexPage');
    },
    close: function(response) {
      console.log("close", response);
//       container.style.opacity = 0;
      container.style.visibility = "hidden";
    }
  }
);
}

function getToken(){
  
  var retake = $('.btn-scan').attr('retake');
  console.log(retake);
  if(retake == true || retake == 'true') {
    delete_cookie('vtoscanid');
    delete_cookie('vtooverlay');
			jQuery('button.btn-scan').html('Virtual Me');
            jQuery('button.btn-scan').attr('retake', 'false');
    getToken();
    jQuery('button.btn-scan').removeClass('ditto-tryon');
  }else {
$('#ditto-tryon').addClass('scan-opened');
			jQuery('button.btn-scan').html('Retake');
            jQuery('button.btn-scan').attr('retake', 'true');
  // Set up our HTTP request
  var xhr = new XMLHttpRequest();

  // Setup our listener to process completed requests
  xhr.onload = function () {

      // Process our return data
      if (xhr.status >= 200 && xhr.status < 300) {
			let response =JSON.parse(xhr.responseText);
        	signature = response["X-Ditto-Signature"];
        
        	console.log('signature', signature);
	        checkVTO();
      } else {
			getToken();
      }
  };

  // Create and send a GET request
  // The first argument is the post type (GET, POST, PUT, DELETE, etc.)
  // The second argument is the endpoint URL
  xhr.open('GET', 'https://projectsouleyewear.com/tools/token');
  xhr.send();
}
}

function delete_cookie(name) {
  document.cookie = name +'=; Expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
  console.log('delete');
}

function changeTryOnVariant(id_model){
  if(scanID != ""){
  	let scanContainer = document.getElementById("scan-iframe");
    if(scanContainer){
      scanContainer.style.display = "none";
    }
    

    var overlay = new Ditto.Overlay(
      {
        tryOnServer: "https://vto.partners-au.api.ditto.com",
        partnerId: "projectsoul",
        domSelector: "#ditto-tryon",
        scanId: scanID,
        glassesId: id_model,
        overlaySignature: overlaySignature,
        accessKey: AccessKey
      },
      {
        initialized: function() {
          console.log("initialized");
        },
        success: function() {
          let x = document.getElementsByClassName("first-ditto");
          container.style.visibility = "hidden";
        },
        failure: function() {
          console.log("Failure");
          container.style.visibility = "hidden";
        },
        onclick: function() {
          console.log("Optional Event: Click of VTO");
        }
      }
    );
  }
}